import React from "react";
import { Typography } from "@mui/material";
import Table from "../../../../../components/table/table";
import { linkedAssetsColumns } from "./columns";

const LinkedAssets = ({ linkedAssets, handleDeleteLink }) => {
  const isEmpty = !linkedAssets || linkedAssets.length === 0;

  return (
    <div>
      {isEmpty ? (
        <Typography variant="body4" style={{ textAlign: "center" }}>
          There are no assets associated with this project.
        </Typography>
      ) : (
        <Table
          data={linkedAssets}
          columns={linkedAssetsColumns(handleDeleteLink)}
        />
      )}
    </div>
  );
};

export default LinkedAssets;
